import { HQO_SDK_ACTIONS } from './types/sdk-message.types';

export const HQO_SDK_EVENT_NAME = 'hqoSdkEvents';
export const WINDOW_POST_MESSAGE_EVENT_NAME = 'message';
export const POST_MESSAGE_TARGET_ORIGIN = '*';
export const HQO_SDK_EVENT_SUFFIX = 'Response';
export const HQO_SDK_EVENTS_SET = new Set(
  Object.values(HQO_SDK_ACTIONS).map((sdkAction) => `${sdkAction}${HQO_SDK_EVENT_SUFFIX}`),
);
export const EMBED_PARAMETER_NAME = 'embed';
export const INIT_TIMEOUT_MESSAGE = 'sdk init timeout';
export const DEFAULT_INIT_TIMEOUT = 7_000;
export const DEFAULT_GATEWAY_ID = 6;
export const SECONDS_MULTIPLIER = 1_000;
